import {createElement, createContext} from 'react';
import {getFlags} from './featureFlags';

export const FeatureFlagContext = createContext({});

export const FeatureFlagProvider = ({debugModel, children}) => {
  const {activeThru} = debugModel;
  const envFlags = debugModel[activeThru];
  const overrideFlags = getFlags(localStorage);
  const flags = {...envFlags, ...overrideFlags};

  return createElement(FeatureFlagContext.Provider, {value: flags}, children);
};

export const FeatureFlagConsumer = FeatureFlagContext.Consumer;
